// تسميات مشتركة بين تقريري الرواتب والحضور (الختم، الترقيم، التوقيع، الإجماليات، التحقق).
export const COMMON = {
  ar: {
    totalsLabel: "الإجماليات",
    verifyTitle: "تحقق من أصالة هذا التقرير",
    pageOf: "صفحة {i} من {n}",
    signTitle: "التوقيع والاعتماد",
    signNameDate: "الاسم والتاريخ",
    print: "طباعة",
    downloadPdf: "تحميل PDF",
    sharePdf: "مشاركة PDF",
    close: "✕ إغلاق",
    share: "مشاركة التقرير",
    copyLink: "نسخ الرابط",
    copied: "تم نسخ الرابط",
    reference: "الرقم المرجعي:",
    shareNote: "الرابط صالح 7 أيام ويُفتح بلا تسجيل دخول.",
  },
  en: {
    totalsLabel: "Totals",
    verifyTitle: "Verify the authenticity of this report",
    pageOf: "Page {i} of {n}",
    signTitle: "Signatures and approval",
    signNameDate: "Name and date",
    print: "Print",
    downloadPdf: "Download PDF",
    sharePdf: "Share PDF",
    close: "✕ Close",
    share: "Share report",
    copyLink: "Copy link",
    copied: "Link copied",
    reference: "Reference:",
    shareNote: "This link works for 7 days and needs no sign-in.",
  },
};
